module.exports = __webpack_public_path__ + "static/media/benchmark.b6c4c1b3.jpg";